import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '@core/bootstrap/menu.service';
import { HelpService } from '@shared';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private helpService = inject(HelpService);
  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);
  protected menuService = inject(MenuService);

  title = '';

  description = '';

  items: any;

  ngOnDestroy(): void {
    this.helpService.reset();
  }

  ngOnInit() {
    this.loadItems();
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }

  protected loadItems() {
    this.items = this.menuService.getFilteredMenu$();

    this.activatedRoute.data.subscribe(data => {
      this.title = data.title;
      this.description = data.description;
      if (data.helpId) {
        this.helpService.set(data.helpId);
      }
    });
  }
}
